import moment from 'moment';

import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';

import {
  generateAssessmentCertificateUrl,
  getQuizAssessment,
  updateAssessmentCertificateUrl,
} from '../../../../../services/apiService';

import { toast } from 'react-toastify';

const certiCharCount = 60;

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};

const pageSize = 10;

function QuizAssessment({ goalType, userId }) {
  const [rowData, setRowData] = useState(null);

  const fetchData = async () => {
    try {
      if (goalType && userId) {
        const response = await getQuizAssessment(goalType, userId);
        setRowData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };
  const handleGenerateCertificate = async (data, setLoading) => {
    try {
      setLoading(true);
      const payload = {
        userId: userId,
        assessmentId: data?.id,
      };
      const response = await generateAssessmentCertificateUrl(payload);
      if (response) {
        await fetchData();
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Error Occured');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateCertificate = async (data, setUpdate) => {
    try {
      setUpdate(true);
      const apiData = {
        userId: userId,
        assessmentId: data?.id,
      };
      const response = await updateAssessmentCertificateUrl(apiData);
      if (response) {
        await fetchData();
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Error Occured');
    } finally {
      setUpdate(false);
    }
  };

  const columnDefs = [
    { field: 'id', hide: true },

    { field: 'name', headerName: 'Name' },
    { field: 'type' },
    {
      field: 'generateCertificate',
      headerName: 'Generate Certificate',
      cellRenderer: (params) => {
        return (
          <div>
            {params?.data?.generateCertificate === true ? 'True' : 'False'}
          </div>
        );
      },
    },
    { field: 'attempts' },
    {
      field: 'bestAttempt',
      headerName: 'Best Attempt',
      valueFormatter: (params) => {
        return params?.value
          ? moment(params?.value).format('DD MMM YYYY')
          : '-';
      },
    },
    { field: 'bestScore' },
    {
      field: 'certificateUrl',
      headerName: 'Certificate',
      width: 600,
      cellRenderer: (params) => {
        const [loading, setLoading] = useState(false);
        const [update, setUpdate] = useState(false);

        return params?.data?.bestScore >= 60 &&
          params?.value === null &&
          params?.data?.generateCertificate === true ? (
          <button
            onClick={() => {
              handleGenerateCertificate(params.data, setLoading);
            }}
            disabled={loading}
            style={{
              fontSize: 13, fontWeight: 500, padding: '4px 8px', borderRadius: 4, cursor: loading ? 'not-allowed' : 'pointer',
              backgroundColor: 'var(--card-background, #fff)',
              color: loading ? 'var(--text-muted, #9CA3AF)' : 'var(--primary-main, #60A5FA)',
              border: `1px solid ${loading ? 'var(--text-muted, #9CA3AF)' : 'var(--primary-main, #60A5FA)'}`,
              opacity: loading ? 0.5 : 1,
            }}
          >
            Generate Certificate
          </button>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', color: 'var(--primary-main, #2563EB)', height: '100%' }}>
            {params.value && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <a
                  href={params.value}
                  target='_blank'
                  rel='noreferrer'
                  style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 20, fontSize: 13, fontWeight: 400, width: '100%', wordBreak: 'break-all', color: 'var(--primary-main, #2563EB)' }}
                >
                  {params.value && params.value.length > certiCharCount
                    ? params.value.substring(0, certiCharCount) + '...'
                    : params.value}
                </a>
                <button
                  onClick={() => {
                    handleUpdateCertificate(params.data, setUpdate);
                  }}
                  disabled={update}
                  style={{
                    fontSize: 13, fontWeight: 500, padding: '4px 8px', borderRadius: 4, cursor: update ? 'not-allowed' : 'pointer',
                    backgroundColor: 'var(--card-background, #fff)',
                    color: update ? 'var(--text-muted, #9CA3AF)' : 'var(--primary-main, #60A5FA)',
                    border: `1px solid ${update ? 'var(--text-muted, #9CA3AF)' : 'var(--primary-main, #60A5FA)'}`,
                    opacity: update ? 0.5 : 1,
                  }}
                >
                  Update Certificate
                </button>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, [goalType, userId]);

  return (
    <div>
      <div
        className='ag-theme-alpine h-96  w-full'
        style={{ height: '490px' }}
      >
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
}

export default QuizAssessment;
